// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".partners-slider__slide[data-v-4462162a]{width:96px;height:60px;margin:0 8px 8px 0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
